"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VulnerableCustomerPaymentHolidayPaymentSchedule = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var moment = require("moment/moment");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../helpers/commonFunctions");
var VulnerableCustomerPaymentHolidayPaymentSchedule = /** @class */ (function (_super) {
    __extends(VulnerableCustomerPaymentHolidayPaymentSchedule, _super);
    function VulnerableCustomerPaymentHolidayPaymentSchedule(props) {
        var _this = _super.call(this, props) || this;
        _this.progressContainerRef = React.createRef();
        _this.lastDoneInstalmentDotRef = React.createRef();
        _this.renderHorizontalDots = function () {
            return _this.state.instalments.map(function (instalment, index) {
                var isDone = index <= _this.state.lastDoneInstalmentIndex;
                return ((0, jsx_runtime_1.jsx)("div", { className: "progress-dot".concat(isDone ? " progress-dot--paid" : ""), ref: index === _this.state.lastDoneInstalmentIndex ? _this.lastDoneInstalmentDotRef : undefined }, instalment.month));
            });
        };
        _this.renderVerticalDotsWithSchedule = function () {
            return _this.state.instalments.map(function (instalment, index) {
                var amount = instalment.principal + instalment.interest;
                var isDone = index <= _this.state.lastDoneInstalmentIndex;
                return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__grid-item instalment-text-color ".concat(isDone ? "font-weight-bold" : ""), children: moment(instalment.dueDate).format("DD MMM YYYY") }), (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__grid-item", children: (0, jsx_runtime_1.jsx)("div", { className: "progress-dot".concat(isDone ? " progress-dot--paid" : ""), ref: index === _this.state.lastDoneInstalmentIndex ? _this.lastDoneInstalmentDotRef : undefined }) }), (0, jsx_runtime_1.jsxs)("div", { className: "payment-schedule__grid-item payment-plan-item instalment-text-color ".concat(isDone ? "font-weight-bold" : "", " "), children: [amount === 0 ? "Payment Holiday" : "".concat((0, commonFunctions_1.getAmountToDisplay)(amount)), " ", index === 0 ? "(Deposit)" : ""] })] }, instalment.month));
            });
        };
        _this.createPaymentHolidayGaps = function () {
            var _a = _this.props, instalmentPlanInfo = _a.instalmentPlanInfo, paymentHolidayMonths = _a.paymentHolidayMonths;
            var paidInstalments = instalmentPlanInfo.paidInstalments, unpaidInstalments = instalmentPlanInfo.unpaidInstalments;
            var lastPaidInstalmentDate = moment(paidInstalments[paidInstalments.length - 1].dueDate);
            var firstUnpaidInstalmentDate = moment(unpaidInstalments[0].dueDate);
            var firstPaymentHoliday = paidInstalments.length > 1
                ? lastPaidInstalmentDate.add(1, 'months')
                : firstUnpaidInstalmentDate.subtract(paymentHolidayMonths, 'months');
            var writtenInstalments = Array.from({ length: paymentHolidayMonths }, function (_, i) {
                var due = moment(firstPaymentHoliday).add(i, 'months');
                return {
                    dueDate: due.toISOString(),
                    month: String(due.month() + 1),
                    principal: 0,
                    interest: 0
                };
            });
            var instalments = paidInstalments.concat(writtenInstalments, unpaidInstalments);
            _this.setState({
                instalments: instalments
            });
        };
        _this.state = {
            lastDoneInstalmentIndex: -1,
            instalments: []
        };
        return _this;
    }
    VulnerableCustomerPaymentHolidayPaymentSchedule.prototype.componentDidMount = function () {
        var paidInstalmentCount = this.props.instalmentPlanInfo.paidInstalments.length - 1;
        this.createPaymentHolidayGaps();
        this.setState({
            lastDoneInstalmentIndex: paidInstalmentCount
        });
    };
    VulnerableCustomerPaymentHolidayPaymentSchedule.prototype.componentWillUnmount = function () {
        if (this.windowResizeEventSubscription) {
            this.windowResizeEventSubscription.unsubscribe();
        }
    };
    VulnerableCustomerPaymentHolidayPaymentSchedule.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "payment-schedule ".concat(this.props.isOpen ? "payment-schedule--open" : ""), children: [(0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__progress-container", ref: this.progressContainerRef, children: (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__progress", children: (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__progress-bar" }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__dot-container", children: this.props.isOpen ? this.renderVerticalDotsWithSchedule() : this.renderHorizontalDots() })] }));
    };
    VulnerableCustomerPaymentHolidayPaymentSchedule = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], VulnerableCustomerPaymentHolidayPaymentSchedule);
    return VulnerableCustomerPaymentHolidayPaymentSchedule;
}(React.Component));
exports.VulnerableCustomerPaymentHolidayPaymentSchedule = VulnerableCustomerPaymentHolidayPaymentSchedule;
//# sourceMappingURL=VulnerableCustomerPaymentHolidayPaymentSchedule.js.map